import { CheckCircle2, Mail, ArrowRight } from 'lucide-react';
import Footer from '../components/Footer';
import { usePageView } from '../hooks/usePageView';

export default function ThankYou() {
  usePageView('purchase_completed');

  return (
    <>
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-green-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center border border-green-100">
          <div className="flex justify-center mb-6">
            <div className="bg-green-100 rounded-full p-4">
              <CheckCircle2 className="w-16 h-16 text-green-600" />
            </div>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Willkommen an Bord!
          </h1>

          <p className="text-xl text-gray-600 mb-4">
            Deine Anmeldung war erfolgreich. Deine Transformation beginnt jetzt!
          </p>

          <p className="text-sm text-gray-500 mb-8">
            Die Abbuchung erfolgt durch Digistore24 GmbH (Deutschland)
          </p>

          <div className="bg-green-50 rounded-2xl p-6 mb-8 border-2 border-green-200">
            <div className="flex items-start gap-4 text-left">
              <div className="bg-green-600 rounded-full p-3 flex-shrink-0">
                <Mail className="w-6 h-6 text-white" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-900 mb-2">
                  Überprüfe dein E-Mail-Postfach
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Wir haben dir soeben eine E-Mail mit deinen persönlichen Zugangsdaten gesendet.
                  Bitte überprüfe auch deinen Spam-Ordner, falls du die E-Mail nicht sofort findest.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-4 mb-8">
            <div className="flex items-center gap-3 text-left p-4 bg-gray-50 rounded-xl">
              <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                1
              </div>
              <p className="text-gray-700">
                <span className="font-semibold">Zugangsdaten:</span> In der E-Mail findest du deine Login-Daten für das Programm
              </p>
            </div>

            <div className="flex items-center gap-3 text-left p-4 bg-gray-50 rounded-xl">
              <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                2
              </div>
              <p className="text-gray-700">
                <span className="font-semibold">Sofort starten:</span> Logge dich ein und beginne noch heute mit Modul 1
              </p>
            </div>

            <div className="flex items-center gap-3 text-left p-4 bg-gray-50 rounded-xl">
              <div className="w-8 h-8 bg-green-600 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">
                3
              </div>
              <p className="text-gray-700">
                <span className="font-semibold">Community:</span> Tritt unserer Community bei und tausche dich mit anderen aus
              </p>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <p className="text-gray-600 mb-6">
              Hast du Fragen? Unser Support-Team ist für dich da!
            </p>
            <a
              href="mailto:support@vegitech.de"
              className="inline-flex items-center gap-2 bg-green-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-green-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
            >
              Kontaktiere uns
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>

          <p className="mt-8 text-sm text-gray-500">
            Wir freuen uns darauf, dich auf deiner Reise zu begleiten! 🌱
          </p>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}
